<template>
  <el-dialog
    :visible.sync="dialogVisible"
    width="350px"
    custom-class="call-store-container" 
  >
    <div class="title">联系客服</div>
    <div class="cellphone">
      <span class="phone-title">客服电话:</span>
      <span class="phone-content">{{ phone }}</span>
    </div>
    <div class="btn-box">
      <!-- <div class="cancel common-btn">取消</div> -->
      <div class="confirm common-btn" @click="dialogVisible = false">确定</div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    phone: {
      type: String,
      default: '',
    }
  },
  data() {
    return {
      dialogVisible: false
    }
  },
  methods: {
    showDialog() {
      this.dialogVisible = true
    }
  }
}
</script>

<style lang="scss">
.call-store-container {
  .el-dialog__header {
    display: none;
  }
  .el-dialog__body {
    display: flex;
    flex-direction: column;
    padding: 20px;
  }
}
</style>
<style scoped lang="scss">
.call-store-container {
  .title {
    text-align: center;
  }
  .cellphone {
    margin-top: 20px;
    background: #eeeeee;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 40px;
    .phone-title {
      margin-left: 10px;
    }
    .phone-content {
      margin-right: 10px;
    }
  }
  .btn-box {
    margin-top: 20px;
    display: flex;
    align-items: center;
    gap: 10px;
    justify-content: center;
    .common-btn {
      user-select: none;
      width: 200px;
      height: 35px;
      line-height: 35px;
      text-align: center;
      border-radius: 40px;
      cursor: pointer;
      font-size: 16px;
      &.cancel {
        background: #eeeeee;
        color: #999999;
      }
      &.confirm {
        background: linear-gradient(270deg, #EE8C54 0%, #EA553C 100%);
        color: #ffffff;
      }
    }
  }
}
</style>